import { FieldType, Model, Schema } from "@core/index";

export interface ILegalMember {
    id?: number;
    name?: string;
    nationalId?: string;
    memberId?: string;
    modifyTime?: number;
    insertTime?: number;
    enable?: boolean;
}

export class LegalMember extends Model implements ILegalMember {
    public static schema: Schema = new Schema("LegalMember");
    public id?: number;
    public name?: string;
    public nationalId?: string;
    public memberId?: string;
    public modifyTime?: number;
    public insertTime?: number;

    constructor(values: ILegalMember) {
        super(LegalMember.schema);
        this.setValues(values);
    }
}

LegalMember.schema.addField("name").type(FieldType.String).required();
LegalMember.schema.addField("nationalId").type(FieldType.String).required();
LegalMember.schema.addField("memberId").type(FieldType.String);
LegalMember.schema.addField("modifyTime").type(FieldType.Number);
LegalMember.schema.addField("insertTime").type(FieldType.Number);
LegalMember.schema.freeze();